import { getOtpAction, verifyOtpAction } from '../../../store/actions/UserActions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { trackVerifyUsernameEvent } from '../../../../../utils/railsAnalytics';

type EmailAndMobileState = {
  disabledByMobile: boolean,
  disabledByEmail: boolean,
  rotate: boolean,
  validationFail: boolean,
  emailOtp: string,
  mobileOtp: string,
  sentVerifyCall: boolean,
  resendOtpEnabled: boolean,
};

const initialStates = {
  disabledByMobile: true,
  disabledByEmail: true,
  rotate: false,
  validationFail: true,
  emailOtp: '',
  mobileOtp: '',
  sentVerifyCall: false,
  resendOtpEnabled: true,
};

export const useEmailAndMobileNotVerifiedContainer = (props) => {
  const dispatch = useDispatch();
  const { user: { getOtpResponse, verifyOtpResponse, userStatus } } = useSelector((state: any) => {
    return state;
  } );
  const [ state, setState ] = useState<EmailAndMobileState>(initialStates);
  const [ errorMessage, setErrorMessage] = useState('');
  const [ showModal, setShowModal ] = useState<boolean>(props.showModal || false);
  const timer = useRef(null);

  /*send otp to user*/
  useEffect(() => {
    setState(initialStates);
    dispatch(getOtpAction(props.userStatus.userId, 'B'));
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  useEffect(() => {
    if (getOtpResponse.error && getOtpResponse.userID === userStatus.userId) {
      setState({
        ...state,
        resendOtpEnabled: false,
      });
      setErrorMessage('You have sent too many OTP requests for this username.');
    }

    if (verifyOtpResponse.error && verifyOtpResponse.userID === userStatus.userId ) {
      setState({
        ...state,
      });
      setErrorMessage(verifyOtpResponse.error);
      //In case of mobile, need to check
      //goToUserVerifiedPage(nextProps.verifyOtpResponse);
    } else if (verifyOtpResponse.status && state.sentVerifyCall) {
      goToUserVerifiedPage(verifyOtpResponse);
    }

  }, [ verifyOtpResponse.status, verifyOtpResponse.error, getOtpResponse ]);

  useEffect(() => {
    if (userStatus.error) {
      setState({
        ...state,
        resendOtpEnabled: false,
      });
      setErrorMessage(userStatus.error);
    }
  }, [ userStatus.error ]);

  const handleInputKeyUpViaParentMobile=(val) => {
    if (val && val.length > 0) {
      setState({
        ...state,
        disabledByMobile: false,
        mobileOtp: val,
      });
    } else {
      setState({
        ...state,
        disabledByMobile: true,
      });
    }
  };

  const handleInputKeyUpViaParentEmail=(val) => {
    if (val && val.length > 0) {
      setState({
        ...state,
        disabledByEmail: false,
        emailOtp: val,
      });
      setErrorMessage('');
    } else {
      setState({
        ...state,
        disabledByEmail: true,
      });
    }
  };

  const goToIRCTCRegistrationPage = () => {
    trackVerifyUsernameEvent('create_irctc_account_clicked');
    props.createAccount();
  };

  const goToForgotUsernamePage = () => {
    trackVerifyUsernameEvent('irctc_forgot_username_clicked');
    props.switchModal('forgotUsername');
  };

  const closeModal = () => {
    setState({
      ...state,
    });
    setErrorMessage('');
    setShowModal(false);
    props.closeModal();
  };

  const goToUserVerifiedPage =(verifyOtpResponse) => {
    if (props.emailMobileNotVerified) {
      props.updateVerifiedUser(verifyOtpResponse.user_id);
    } else if (props.isEmailNotVerified && props.isMobileNotVerified) {
      const verifyOtpResponseWithUserId = { ...verifyOtpResponse, userId: verifyOtpResponse.user_id };
      props.switchModal('usernameVerified', verifyOtpResponseWithUserId);
    }
  };

  const rotateLoader=() => {
    const { disabledByMobile, disabledByEmail, emailOtp, mobileOtp } = state;
    if (!(disabledByMobile || disabledByEmail)) {
      setState({
        ...state,
        rotate: true,
        sentVerifyCall: true,
      });

      const queryparams = { emailCode: emailOtp,
        smsCode: mobileOtp };

      let otpType;
      if (props.isEmailNotVerified) {
        otpType = 'E';
      } else if (props.isMobileNotVerified) {
        otpType = 'M';
      } else {
        otpType = 'B';
      }

      dispatch(verifyOtpAction(userStatus.userId, otpType, queryparams));
      timer.current = setTimeout(() => {
        setState({
          ...state,
          rotate: false,
        });
      }, 1500);
    }
  };

  return {
    props: {
      showModal,
      state,
      userStatus,
      errorMessage,
    },

    action: {
      rotateLoader,
      closeModal,
      goToIRCTCRegistrationPage,
      goToForgotUsernamePage,
      handleInputKeyUpViaParentEmail,
      handleInputKeyUpViaParentMobile,
    },
  };
};
